export const NOTIFICATION_HIDE_TIMEOUT = 3000;
export const TALK_WHILE_MUTED_HIDE_TIMEOUT = 5000;
export const CAMERA_ON_CLASSNAME = 'wizy-icon enabled';
export const CAMERA_OFF_CLASSNAME = 'wizy-icon disabled';
export const FOUR_K_CAMERA_ICON_CLASSNAME = 'fa fa-cam-4k';
export const PTZ_CAMERA_ICON_CLASSNAME = 'fa fa-cam-ptz';
export const CAM_CON_ICON_CLASSNAME = 'fa fa-cam-control';
export const WIZYCONF_4K_CAMERA = 'wizyconf-4kcam';
export const WIZYCONF_PTZ_CAMERA = 'wizyconf-ptzcam';
export const CAMERA_ICON_CLASSNAME = 'fa fa-cam-on';
export const CAMERA_OFF_ICON_CLASSNAME = 'fa fa-cam-off';
/**
 * Class handles specific for Wizyconf events for PTZ camera
 */
export const CAMERA_CONTROLL_CLASSNAME = 'camera-mode';
export const CAMERA_CONTROLL_CONTENT_CLASSNAME = 'camera-mode__content';
export const CAMERA_CONTROLL_ICON_CLASSNAME = 'fa fa-ptz-camera';
export const CAMERA_CONTROLL_HOLDER = 'remoteVideos';
export const CAMERA_CONTROLL_SELECTOR = `#${CAMERA_CONTROLL_HOLDER} .${CAMERA_CONTROLL_CLASSNAME}`;
export const CAMERA_CONTROLL_TEXT_CLASSNAME = 'camera-mode__title';
export const LOGOUT_FROM_WIZYCONF_ROOM = 'logoutFromWizyconfRoom';
